import { inject, Injectable } from '@angular/core';

import { generateUuid } from '@core/utils-legacy';

import { AssistantRunService } from './run/assistant-run.service';
import { TellentAssistantThreadsFacade } from './tellent-assistant-threads.facade';

@Injectable({ providedIn: 'root' })
export class TellentAssistantFacade {
  private readonly run = inject(AssistantRunService);
  private readonly threads = inject(TellentAssistantThreadsFacade);

  public readonly messages = this.run.messages;
  public readonly runStatus = this.run.runStatus;
  public readonly currentThreadId = this.run.currentThreadId;
  public readonly lastError = this.run.lastError;

  public send(text: string): void {
    if (this.run.runStatus() === 'running') return;
    this.run.send(text);
  }

  public cancelRun(): void {
    this.run.cancelRun();
  }

  public newThread(): void {
    this.run.cancelRun();
    this.run.startNewThread(generateUuid());
  }

  public switchThread(id: string): void {
    this.run.cancelRun();
    this.run.switchToExistingThread(id);
    this.threads.loadCurrent(id);
  }
}
